export default __webpack_public_path__ + "static/Крысиные бега_24-feab170836aae60245f78eb4e580e955.jpg";